import {
  bankAccountSchema,
  type BankAccount,
  type UpdateBankAccountBody,
} from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const patchAccount = (id: string, body: UpdateBankAccountBody): Promise<unknown> =>
  apiRequest<unknown>(`/bank/accounts/${id}`, { method: 'PATCH', body });

export const updateBankAccount = async (
  id: string,
  body: UpdateBankAccountBody,
): Promise<BankAccount> => bankAccountSchema.parse(await patchAccount(id, body));
